import NoiseInput from '../inputs/noise';
import Frequency from '../process-data/frequency';
import FilterConstants from '../../filter-constants';
import { formatFieldValue } from '../../utils/format';
import type IndexModel from '../index';

export default class NoiseAdvisor {
  model: IndexModel; // takes in the domain model

  constructor(model: IndexModel) {
    this.model = model;
  }

  // Creates the noise input model
  // Inputs:
  //   - data : input model values, if this is null, defaults are used
  // Returns: noise input model
  generate(data: NoiseInput): NoiseInput {
    const filter = this.model.results.filter;
    const filterFrequencyRange = this.model.results.specifications.filterFrequencyRange;
    const stopFrequency = filterFrequencyRange.stopFrequency;
    return new NoiseInput(data ? data : { adcBandwidth: filter.getAdcFrequency(stopFrequency) });
  }

  // Creates a Copy of the Noise Input Model
  // Inputs:
  //   - sourceStage : model to be copied from
  // Returns: result - a newly created noise input model with values copied from the source model
  clone(sourceModel: NoiseInput): NoiseInput {
    const result = new NoiseInput();
    result.adcBandwidth = sourceModel.adcBandwidth;
    return result;
  }

  // Validate Noise Input Model
  // Inputs:
  //   - noiseInput : Noise Input model
  //   - invalidFields : array of string containing fields with parse errors
  // Returns: result - Array of error messages
  validate(noiseInput: NoiseInput, invalidFields: Array<string>): Array<ValidationError> {
    const filterFrequencyRange = this.model.results.specifications.filterFrequencyRange;
    const startFrequency = filterFrequencyRange.startFrequency;
    const adcBandwidth = Math.max(noiseInput.adcBandwidth * 10, filterFrequencyRange.stopFrequency);

    const frequencyArray = Frequency.create({
      startFrequency: startFrequency,
      stopFrequency: adcBandwidth,
      pointsPerDecade: filterFrequencyRange.pointsPerDecade,
    }).narrowFrequencyArray;
    const result = [];
    if (invalidFields.indexOf('adcBandwidth') === -1) {
      if (noiseInput.adcBandwidth < frequencyArray[1]) {
        const item = {
          tab: FilterConstants.tabs.components,
          fields: ['adcBandwidth'],
          id: 'adcBandwidthIsLessThanMinimum',
          parameters: {
            minimum: formatFieldValue(frequencyArray[1], FilterConstants.fieldTypes.Engineering, '3s'),
            maximum: FilterConstants.Limits.INFINITY.toString(),
            value: formatFieldValue(noiseInput.adcBandwidth, FilterConstants.fieldTypes.Engineering, '3s'),
          },
        };
        result.push(item);
      }
    }
    return result;
  }
}
